const PAGINATION_SIZE = 50;
export const MAX_PAGINATION_SIZE = 2147483647;
export const GET_ALL_PRODUCTS_IN_ORG = -1;
export const PRODUCT_SEARCH_PAGE_SIZE = 100;
export const INVENTORY_PRODUCT_SEARCH_PAGE_SIZE = 600;
export default PAGINATION_SIZE;
